import { Button } from 'components'
import { DOTS, usePagination } from 'hooks'
import React from 'react'

import {
  ArrowSmLeftIcon,
  ArrowSmRightIcon,
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon
} from '@heroicons/react/solid'
import { tx } from '@twind/core'

const Pagination = ({
  onPageChange,
  totalCount,
  currentPage,
  pageSize,
  paginationContainer,
  buttonVariant,
  selectedButtonVariant,
  siblingCount = 1
}: {
  onPageChange: (_: number) => void
  totalCount: number
  currentPage: number
  pageSize: number
  paginationContainer?: string
  buttonVariant?:
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'warning'
    | 'success'
    | 'transparent'
  selectedButtonVariant?:
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'warning'
    | 'success'
    | 'transparent'
  siblingCount?: number
}) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  })

  if (currentPage === 0 || paginationRange.length < 2) {
    return null
  }

  const onNext = () => {
    onPageChange(currentPage + 1)
  }

  const onPrevious = () => {
    onPageChange(currentPage - 1)
  }

  const lastPage = paginationRange[paginationRange.length - 1]

  return (
    <div
      className={tx(
        'flex gap-2 margin-2 justify-center items-center my-4 py-2 mx-2 px-1 overflow-x-auto max-w-5xl',
        `${paginationContainer || ''}`
      )}>
      <Button
        variant={buttonVariant || 'primary'}
        disabled={currentPage === 1}
        onClick={() => onPageChange(1)}>
        <ChevronDoubleLeftIcon className={'h-6 w-6'} />
      </Button>

      <Button
        variant={buttonVariant || 'primary'}
        disabled={currentPage === 1}
        onClick={onPrevious}>
        <ArrowSmLeftIcon className={'h-6 w-6'} />
      </Button>

      {paginationRange.map((pageNumber) => {
        if (pageNumber === DOTS) {
          return (
            <span key={pageNumber} className="text-lg text-white px-1 mx-1">
              &#8230;&#8230;&nbsp;&nbsp;
            </span>
          )
        }

        return (
          <Button
            key={pageNumber}
            variant={
              pageNumber === currentPage
                ? selectedButtonVariant || 'secondary'
                : buttonVariant || 'primary'
            }
            className={tx('pagination-item')}
            onClick={() => {
              if (
                typeof parseInt(String(pageNumber)) === 'number' &&
                pageNumber !== DOTS
              ) {
                onPageChange(parseInt(String(pageNumber)))
              }
            }}>
            {pageNumber}
          </Button>
        )
      })}

      <Button
        variant={buttonVariant || 'primary'}
        disabled={currentPage === lastPage}
        onClick={onNext}>
        <ArrowSmRightIcon className={'h-6 w-6'} />
      </Button>

      <Button
        variant={buttonVariant || 'primary'}
        disabled={currentPage === lastPage}
        onClick={() => {
          if (
            typeof parseInt(String(lastPage)) === 'number' &&
            lastPage !== DOTS
          ) {
            onPageChange(parseInt(String(lastPage)))
          }
        }}>
        <ChevronDoubleRightIcon className={'h-6 w-6'} />
      </Button>
    </div>
  )
}

export default Pagination
